// JavaScript Document
const ALERTS = document.querySelectorAll(".weblinx-alert-block");

if (ALERTS) {
    console.log("alerts found");
    // foreach loop on alerts
    ALERTS.forEach(ALERT => {
        // get value of `data-hash="..."` from ALERT
        const alert_hash = ALERT.dataset.hash;

        console.log("hash: " + alert_hash);

        /**
         * Open the alert immediately if it was not previously hidden
         */
        if (sessionStorage.getItem(`weblinx-alert-hidden-${alert_hash}`) === "true") {
            ALERT.classList.remove("weblinx-alert-block--state-active");
        }

        /**
         * Find the alert button
         */
        const BUTTON = ALERT.querySelector(".weblinx-alert__button");

        /**
         * On BUTTON click, remove ALERT `weblinx-alert-block--state-active` and store the interaction in sessionStorage
         */
        BUTTON.addEventListener("click", () => {
            ALERT.classList.remove("weblinx-alert-block--state-active");
            sessionStorage.setItem(`weblinx-alert-hidden-${alert_hash}`, "true");
            console.log("button clicked");
        }, { passive: true });
    });
}
